import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ArrowLeft, ShoppingCart, Check, ChevronLeft, ChevronRight, ChevronDown, ChevronUp } from 'lucide-react';
import { useCart } from '../context/CartContext';

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const FitnessProtein = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [addedItems, setAddedItems] = useState({});
  const [showIngredients, setShowIngredients] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const flavors = [
    {
      id: 'vanilla-icecream',
      name: 'בטעם גלידת וניל',
      flavor: 'אבקת חלבון ULTRA WHEY',
      price: 299,
      weight: '2.27 ק"ג (5 LBS)',
      servings: '75 מנות',
      proteinPerServing: '24 גרם חלבון למנה',
      ingredients: 'תערובת חלבון מי גבינה (WPC80, WPI), קקאו, חומרי טעם וריח, מלח, סוכרלוז, תערובת אנזימי עיכול',
      video: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/qf90beix_%2B%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20501%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4'
    },
    {
      id: 'strawberry-white-choc',
      name: 'בטעם מילקשייק תות שוקולד לבן',
      flavor: 'אבקת חלבון ULTRA WHEY',
      price: 299,
      weight: '2.27 ק"ג (5 LBS)',
      servings: '75 מנות',
      proteinPerServing: '24 גרם חלבון למנה',
      ingredients: 'תערובת חלבון מי גבינה (WPC80, WPI), קקאו, חומרי טעם וריח, מלח, סוכרלוז, תערובת אנזימי עיכול',
      video: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/afiep292_%2B%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4'
    },
    {
      id: 'white-choc-caramel',
      name: 'בטעם שוקולד לבן קרמל',
      flavor: 'אבקת חלבון ULTRA WHEY',
      price: 299,
      weight: '2.27 ק"ג (5 LBS)',
      servings: '75 מנות',
      proteinPerServing: '24 גרם חלבון למנה',
      ingredients: 'תערובת חלבון מי גבינה (WPC80, WPI), קקאו, חומרי טעם וריח, מלח, סוכרלוז, תערובת אנזימי עיכול',
      video: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/rubbtmhq_%2B%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4'
    },
    {
      id: 'hazelnut-choc',
      name: 'בטעם שוקולד אגוזי לוז',
      flavor: 'אבקת חלבון ULTRA WHEY',
      price: 299,
      weight: '2.27 ק"ג (5 LBS)',
      servings: '75 מנות',
      proteinPerServing: '24 גרם חלבון למנה',
      ingredients: 'תערובת חלבון מי גבינה (WPC80, WPI), קקאו, חומרי טעם וריח, מלח, סוכרלוז, תערובת אנזימי עיכול',
      video: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/iymq6ghw_%2B%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20501%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.mp4'
    },
    {
      id: 'mocha-cappuccino',
      name: 'בטעם מוקה קאפוצ׳ינו (אייס קפה)',
      flavor: 'אבקת חלבון ULTRA WHEY',
      price: 299,
      weight: '2.27 ק"ג (5 LBS)',
      servings: '75 מנות',
      proteinPerServing: '24 גרם חלבון למנה',
      ingredients: 'תערובת חלבון מי גבינה (WPC80, WPI), קקאו, חומרי טעם וריח, מלח, סוכרלוז, תערובת אנזימי עיכול',
      video: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/a7g2al6r_%2B%20%28700%20x%20500%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%281%29.mp4'
    }
  ];

  const currentFlavor = flavors[currentIndex];

  const nextFlavor = () => {
    setCurrentIndex((prev) => (prev + 1) % flavors.length);
  };

  const prevFlavor = () => {
    setCurrentIndex((prev) => (prev - 1 + flavors.length) % flavors.length);
  };

  const handleButtonClick = (flavor) => {
    if (addedItems[flavor.id]) {
      navigate('/cart');
    } else {
      addToCart({
        id: `protein-${flavor.id}`,
        name: flavor.name,
        description: flavor.flavor,
        price: flavor.price,
        image: '',
        quantity: 1
      });
      
      playCartSound();
      setAddedItems(prev => ({ ...prev, [flavor.id]: true }));
      setShowPopup(true);
      
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  return (
    <div className="container py-8" data-testid="fitness-protein-page">
      {/* Popup */}
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      {/* Back Button */}
      <button
        onClick={() => navigate('/fitness')}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
        data-testid="back-button"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      <div className="max-w-md mx-auto">
        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-bold text-[#2C3E2D] text-center mb-6" style={{ fontFamily: 'Heebo, sans-serif' }}>
          אבקות חלבון
        </h1>

        {/* Product Card with Carousel */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-stone-200">
          {/* Image Carousel */}
          <div className="relative bg-white p-6">
            {/* Navigation Arrows */}
            <button
              onClick={prevFlavor}
              className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 rounded-full shadow-lg flex items-center justify-center hover:bg-[#D97706] hover:text-white transition-colors"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={nextFlavor}
              className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 rounded-full shadow-lg flex items-center justify-center hover:bg-[#D97706] hover:text-white transition-colors"
            >
              <ChevronRight className="w-6 h-6" />
            </button>

            {/* Video */}
            <div className="flex items-center justify-center rounded-xl overflow-hidden" style={{ minHeight: '280px', backgroundColor: '#ffffff' }}>
              <video
                key={currentFlavor.id}
                src={currentFlavor.video}
                autoPlay
                muted
                playsInline
                preload="auto"
                className="w-full h-72 object-contain"
                style={{ pointerEvents: 'none', backgroundColor: '#ffffff' }}
              />
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-4">
              {flavors.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentIndex ? 'bg-[#D97706]' : 'bg-stone-300'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="px-6 py-4 text-center border-t border-stone-100">
            <h3 className="text-xl font-bold text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>
              {currentFlavor.name}
            </h3>
            <p className="text-stone-500 mt-1">{currentFlavor.flavor}</p>
          </div>

          {/* Price, Ingredients and Button */}
          <div className="p-5 bg-stone-50 text-center">
            <div className="text-2xl font-bold text-[#D97706] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
              {currentFlavor.price} ש"ח
            </div>

            {/* Expandable Ingredients */}
            <div className="mb-3">
              <button
                type="button"
                onClick={() => setShowIngredients(!showIngredients)}
                className="w-full flex items-center justify-between px-4 py-2.5 bg-white border border-stone-200 rounded-xl text-sm font-medium text-[#2C3E2D] hover:border-[#D97706] transition-colors"
                style={{ fontFamily: 'Heebo, sans-serif' }}
              >
                <span>רכיבים ומידע תזונתי</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${showIngredients ? 'rotate-180' : ''}`} />
              </button>
              {showIngredients && (
                <div className="mt-2 bg-white border border-stone-200 rounded-xl p-4 text-right text-sm text-stone-600 space-y-2">
                  <div className="flex justify-between"><span className="font-medium text-[#2C3E2D]">משקל:</span><span>{currentFlavor.weight}</span></div>
                  <div className="flex justify-between"><span className="font-medium text-[#2C3E2D]">מנות:</span><span>{currentFlavor.servings}</span></div>
                  <div className="flex justify-between"><span className="font-medium text-[#2C3E2D]">חלבון למנה:</span><span>{currentFlavor.proteinPerServing}</span></div>
                  <div className="border-t border-stone-100 pt-2">
                    <p className="font-medium text-[#2C3E2D] mb-1">רכיבים:</p>
                    <p className="text-xs leading-relaxed">{currentFlavor.ingredients}</p>
                  </div>
                </div>
              )}
            </div>

            <button
              onClick={() => handleButtonClick(currentFlavor)}
              className={`w-full flex items-center justify-center gap-2 px-5 py-3 rounded-full font-bold text-base transition-all duration-300 ${
                addedItems[currentFlavor.id]
                  ? 'bg-green-500 text-white hover:bg-green-600'
                  : 'bg-[#D97706] text-white hover:bg-[#B45309]'
              } hover:shadow-lg`}
              style={{ fontFamily: 'Heebo, sans-serif' }}
            >
              <ShoppingCart className="w-4 h-4" />
              {addedItems[currentFlavor.id] ? 'מעבר לרכישה' : 'הוסף לסל'}
            </button>
          </div>
        </div>

        {/* Flavor Selection */}
        <div className="mt-6 text-center">
          <p className="text-stone-500 text-sm mb-2">בחר טעם:</p>
          <div className="flex justify-center gap-2 flex-wrap">
            {flavors.map((flavor, index) => (
              <button
                key={flavor.id}
                onClick={() => setCurrentIndex(index)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  index === currentIndex
                    ? 'bg-[#D97706] text-white'
                    : 'bg-white text-[#2C3E2D] border border-stone-200 hover:border-[#D97706]'
                }`}
              >
                {flavor.name.replace('בטעם ', '')}
              </button>
            ))}
          </div>
        </div>

        {/* Benefits Section */}
        <div className="mt-10 bg-white rounded-2xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
            למה אבקת חלבון?
          </h2>
          
          <div className="space-y-4 text-stone-600">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-[#D97706]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-[#D97706] font-bold">1</span>
              </div>
              <div>
                <h3 className="font-bold text-[#2C3E2D]">בניית שריר</h3>
                <p className="text-sm">חלבון הוא אבן הבניין העיקרית לשרירים. צריכת חלבון לאחר אימון מסייעת בבניית מסת שריר ושיקום הרקמות.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-[#D97706]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-[#D97706] font-bold">2</span>
              </div>
              <div>
                <h3 className="font-bold text-[#2C3E2D]">התאוששות מהירה</h3>
                <p className="text-sm">אבקת חלבון Whey נספגת במהירות ומספקת לשרירים את החומרים הדרושים להם להתאוששות מיטבית.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-[#D97706]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-[#D97706] font-bold">3</span>
              </div>
              <div>
                <h3 className="font-bold text-[#2C3E2D]">נוחות ויעילות</h3>
                <p className="text-sm">דרך קלה ומהירה לצרוך כמות גדולה של חלבון איכותי, במיוחד כשאין זמן לארוחה מלאה.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-[#D97706]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-[#D97706] font-bold">4</span>
              </div>
              <div>
                <h3 className="font-bold text-[#2C3E2D]">שמירה על מסת שריר</h3>
                <p className="text-sm">בזמן דיאטה או ירידה במשקל, צריכת חלבון מספקת עוזרת לשמור על השרירים ולשרוף שומן.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FitnessProtein;
